import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      '& > div': {
        '& > :nth-child(1)': {
          height: 'auto !important',
          flexGrow: 1,
          overflow: 'auto',
        },
        '& > :nth-child(2)': {
          height: 'auto !important',
        },
      },
    },
  }),
);

export default useStyles;
